import Storage from '@headbright/hb-universal-storage'
import UniversalStorageOptions from '@/plugins/universal-storage-options'

// Nuxt globally
export default function(ctx, inject) {
  // console.log('Nuxt globally')
  const myStorage = new Storage(ctx, UniversalStorageOptions)
  ctx.$storage = myStorage
  inject('storage', myStorage)
}
